document.addEventListener('DOMContentLoaded',function(){
  var root=document.documentElement;

  // Sticky header shadow
  var hdr=document.querySelector('[data-header]');
  if(hdr)addEventListener('scroll',function(){hdr.classList.toggle('scrolled',scrollY>20);},{passive:true});

  // Mobile drawer
  var burger=document.querySelector('[data-burger]'),body=document.body,scrim;
  function closeNav(){body.classList.remove('sd-navopen');}
  if(burger){
    scrim=document.createElement('div');scrim.className='sd-scrim';body.appendChild(scrim);
    burger.addEventListener('click',function(){body.classList.toggle('sd-navopen');});
    scrim.addEventListener('click',closeNav);
    var navclose=document.querySelector('[data-navclose]');
    if(navclose)navclose.addEventListener('click',closeNav);
    document.querySelectorAll('[data-navrow] a').forEach(function(a){a.addEventListener('click',closeNav);});
    addEventListener('keydown',function(e){if(e.key==='Escape')closeNav();});
  }

  // Kinetic scroll reveals. Default (no .js) state is fully visible; the
  // inline js-class hides the start state, and we ALWAYS reveal via observer
  // + a hard timeout failsafe so content can never stay hidden.
  var els=[].slice.call(document.querySelectorAll('.reveal,.reveal-up'));
  function showAll(){els.forEach(function(e){e.classList.add('in');});}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
    els.forEach(function(e){io.observe(e);});
    setTimeout(showAll,2200); // failsafe — nothing stays hidden
  } else { showAll(); }

  // Subtle hero parallax (transform only — safe)
  var heroBg=document.querySelector('.spk-h .hero .bg');
  if(heroBg&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
    addEventListener('scroll',function(){var y=Math.min(scrollY,900);heroBg.style.transform='translate3d(0,'+(y*0.12)+'px,0) scale(1.06)';},{passive:true});
  }

  // PDP swipeable gallery (scroll-snap slider + thumbnails)
  var slider=document.querySelector('[data-pdp-slider]');
  if(slider){
    var slides=[].slice.call(slider.querySelectorAll('[data-pdp-slide]'));
    var thumbs=[].slice.call(document.querySelectorAll('[data-pdp-thumb]'));
    function goTo(i){slider.scrollTo({left:i*slider.clientWidth,behavior:'smooth'});}
    thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(t.getAttribute('data-index'),10)||0);});});
    function setActive(){
      var i=Math.round(slider.scrollLeft/Math.max(slider.clientWidth,1));
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i);});
      // pause any HTML5 videos that scroll out of view
      slides.forEach(function(sl,k){var v=sl.querySelector('video');if(v&&k!==i&&!v.paused)v.pause();});
    }
    var raf;slider.addEventListener('scroll',function(){if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(setActive);},{passive:true});
    addEventListener('resize',setActive);
    setActive();
  }

  // Footer menus: collapsible accordions on mobile, always open on desktop
  document.querySelectorAll('[data-foot-toggle]').forEach(function(h){
    h.addEventListener('click',function(){
      if(matchMedia('(max-width:820px)').matches){h.parentNode.classList.toggle('open');}
    });
  });

  // PDP size chart popup (native <dialog>: Esc closes, focus is trapped)
  var chart=document.querySelector('[data-size-chart]'),chartOpen=document.querySelector('[data-size-chart-open]');
  if(chart&&chartOpen&&chart.showModal){
    chartOpen.addEventListener('click',function(){chart.showModal();});
    chart.querySelector('[data-size-chart-close]').addEventListener('click',function(){chart.close();});
    chart.addEventListener('click',function(e){if(e.target===chart)chart.close();}); // backdrop click
  }

  // PDP live variant price
  var sel=document.querySelector('[data-variant-select]');
  if(sel){sel.addEventListener('change',function(){var o=sel.options[sel.selectedIndex];var p=o.getAttribute('data-price');var el=document.querySelector('[data-cur-price]');if(p&&el)el.textContent=p;});}
});
